type PipelineEntityRouteParam = string | number;

const NUMERIC_ROUTE_PARAM_REGEX = /^\d+$/;

// Normalize known-good ids for typed TanStack builders, but preserve unknown
// strings so malformed deep links still reach the owning route.
function parseNumericRouteParam(value: string): number | string {
  return NUMERIC_ROUTE_PARAM_REGEX.test(value) ? Number(value) : value;
}

function parsePipelineEntityRouteParam(value: string): PipelineEntityRouteParam {
  return value === 'journeys' ? value : parseNumericRouteParam(value);
}

export const sourceRouteParams = {
  parse: ({ sourceId }: { sourceId: string }) => ({ sourceId: parsePipelineEntityRouteParam(sourceId) }),
  stringify: ({ sourceId }: { sourceId: PipelineEntityRouteParam }) => ({ sourceId: String(sourceId) }),
};

export const sourceSyncRouteParams = {
  parse: ({ sourceId, syncId }: { sourceId: string; syncId: string }) => {
    return {
      sourceId: parsePipelineEntityRouteParam(sourceId),
      syncId: parseNumericRouteParam(syncId),
    };
  },
  stringify: ({ sourceId, syncId }: { sourceId: PipelineEntityRouteParam; syncId: string | number }) => ({
    sourceId: String(sourceId),
    syncId: String(syncId),
  }),
};

export const destinationRouteParams = {
  parse: ({ destinationId }: { destinationId: string }) => ({
    destinationId: parsePipelineEntityRouteParam(destinationId),
  }),
  stringify: ({ destinationId }: { destinationId: PipelineEntityRouteParam }) => ({
    destinationId: String(destinationId),
  }),
};

export const subscriptionRouteParams = {
  parse: ({ subscriptionId }: { subscriptionId: string }) => ({
    subscriptionId: parseNumericRouteParam(subscriptionId),
  }),
  stringify: ({ subscriptionId }: { subscriptionId: string | number }) => ({ subscriptionId: String(subscriptionId) }),
};
